"use client";
import { useState, useEffect } from "react";

type ImageSize = "sm" | "md" | "lg";

export function useOptimalImageSize(): ImageSize {
  // Default to "md" for SSR safety to ensure initial render is never blurry
  const [size, setSize] = useState<ImageSize>("lg");

  useEffect(() => {
    if (typeof window === "undefined") return;

    let resizeTimeout: NodeJS.Timeout;

    const checkSize = () => {
      const width = window.innerWidth;

      if (width <= 500) {
        setSize("md");
      } else {
        setSize("lg");
      }
    };

    checkSize();

    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(checkSize, 150);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
}
